import React from 'react'
import Link from '../Link/Link'
import classnames from 'classnames'
import * as PropTypes from 'prop-types'

class SecondaryNavbar extends React.Component {
  // render all navigation items for the current plattform and set the active icon based on the current path
  renderNavItems () {
    return this.props.secondNavItems.map((entry, index) => {
      if (entry.isGithubLink) {
        return SecondaryNavbar.renderGithubLink(entry, index)
      }
      const linkIsInternal = /^\/(?!\/)/.test(entry.to)
      let iconExternal = linkIsInternal ? '' : (<i className='fa fa-external-link ml-1' />)

      let classNames = classnames(
        'second-nav-item d-flex align-items-center justify-content-center font-weight-bold py-3 px-md-3 mx-1 px-0 h-100 text-decoration-none color-black',
        {
          'd-none d-sm-flex': entry.isExternal
        }
      )

      return <Link
        key={'second-nav-link-' + index}
        to={entry.to}
        exact={'true'}
        classNames={classNames}
        activeClassName='active'
      >
        {entry.text}
        {iconExternal}
      </Link>
    })
  }

  static renderGithubLink (entry, index) {
    return (
      <a className='btn btn-secondary btn-sm align-items-center github-link d-none d-sm-flex px-1 py-1 mx-1 h-auto'
        key={'second-nav-link-' + index}
        href={entry.to}
        target='_blank'>
        <i className='fa fa-github mr-1' />
        {entry.text}
      </a>
    )
  }

  render () {
    return (
      <div className='bg-white d-flex align-items-center justify-content-center'>
        {this.renderNavItems()}
      </div>
    )
  }
}

export default SecondaryNavbar

SecondaryNavbar.propTypes = {
  secondNavItems: PropTypes.arrayOf(PropTypes.shape({
    to: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.object,
    isGithubLink: PropTypes.bool,
    isExternal: PropTypes.bool
  }))
}
